<div class="max-w-7xl mx-auto px-6 2xl:px-8 py-6 2xl:py-8">
  <ng-content />
</div>
